/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _8 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>8 - Организация хранилища</h2>
    <p className={styles.description}>
      Необходимо хранить все состояние приложения в Redux? Можно ли использовать{' '}
      <code className={styles.code}>setState()</code>? Как разработчик, ваша задача - определить, из какого набора
      данных состоит приложение, и где их лучше хранить.{' '}
    </p>
    <p className={styles.description}>
      Некоторые общие правила для определения того, какие данные должны быть помещены в Redux. Если ответ да, то есть
      смысл использовать хранилище, а не локальное состояние.{' '}
    </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>Необходимы ли эти данные другим частям приложения? </li>
      <li className={styles.list__item}>Необходимо ли на основе этих данных создавать дополнительные производные?</li>
      <li className={styles.list__item}>
        Используются ли одни и те же данные для управления несколькими компонентами?{' '}
      </li>
      <li className={styles.list__item}>Есть ли необходимость в кешировании? </li>
    </ul>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>8.1 - Дополнительные материалы</h3>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <a
            className={styles.link}
            href="https://medium.freecodecamp.org/where-do-i-belong-a-guide-to-saving-react-component-data-in-state-store-static-and-this-c49b335e2a00"
            target="_blank"
          >
            Where to Hold React Component Data: state, store, static, and this
          </a>
        </li>
        <li className={styles.list__item}>
          <a className={styles.link} href="http://jamesknelson.com/5-types-react-application-state/" target="_blank">
            The 5 Types Of React Application State
          </a>
        </li>
      </ul>{' '}
    </section>
  </section>
))
